import { TLogin, TForgotPassword, TResetPassword, TLogout } from "types";
import { axios } from "./apiConfig";
import { ServiceEndpoints } from "../constants";

export const signup = async (data) => {
  return axios
    .post(ServiceEndpoints.REGISTER, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const createOrganization = async (data) => {
  return axios
    .post(ServiceEndpoints.CREATE_ORGANIZATION, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const login = async (payload: TLogin) => {
  return axios
    .postForm(ServiceEndpoints.LOGIN, payload)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const forgetPassword = async (payload: TForgotPassword) => {
  return axios
    .post(ServiceEndpoints.FORGOT_PASSWORD, payload)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const resetPassword = async (payload: TResetPassword) => {
  return axios
    .post(ServiceEndpoints.CHANGE_PASSWORD, payload)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const logout = async (payload: TLogout) => {
  return axios
    .post(ServiceEndpoints.LOGOUT, payload)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const getRefreshToken = async (refreshToken: string | null) => {
  return axios
    .post(ServiceEndpoints.REFRESH, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      },
    })
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
